




















import Component from 'vue-class-component'
import {Prop, Watch, Vue, Emit} from 'vue-property-decorator'
import {EventBus, Messages} from "../../services/EventBus";
import {Position} from '../../domain/Position'
import {Dropdown } from '../Common'

@Component({
    components: {Dropdown}
})

class PositionActionMenu extends Vue{

    @Prop()
    position: Position;

    show:boolean= false;

    tradeClick() {
        this.hideMenu();
        let order = Position.makeTradeOrder(this.position);
        EventBus.showTradeForm(order);

    }

    closeClick() {
        this.hideMenu();
        let order = Position.makeCloseOrder(this.position);
        EventBus.showTradeForm(order );

    }

    showMenu(){
        this.show= true;
    }

    hideMenu(){
        this.show= false;
    }
}

export default PositionActionMenu;
